import { useStableReadQuery } from 'commons/hooks/react-query/useStableReadQuery'
import { getCompanyDetailsWebPage } from 'commons/service/bank/companyDetails'
import { CompanyDetailsWebPage } from 'commons/types/DTO/bank'

type UseGetCompanyDetailsOptions = {
  clearOnUnmount?: boolean
}

export const COMPANY_DETAILS_KEY = 'companyDetails'

export const useGetCompanyDetailsWebPage = (relationshipId?: number, options?: UseGetCompanyDetailsOptions) =>
  useStableReadQuery<CompanyDetailsWebPage, number | undefined>(
    COMPANY_DETAILS_KEY,
    relationshipId,
    getCompanyDetailsWebPage,
    {
      placeholderDataKeepPrevious: true,
      forceFreshOnMount: true,
      clearOnUnmount: options?.clearOnUnmount,
      requireVariables: true
    }
  )
